import _ from 'lodash';
import * as DialogActions from 'app/dialog/features/dialog.actions';

import { Component, OnInit, Input, ElementRef, OnDestroy, ChangeDetectorRef, ViewChild, AfterViewInit, Inject, DestroyRef, inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { MdbTabsComponent } from 'mdb-angular-ui-kit/tabs';
import { select, Store } from '@ngrx/store';

import { Subject } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';

import { SponsorGroupListService } from 'app/sponsor-group/services/sponsor-group-list.service';
import {
  AccordionService,
  CampaignFormService,
  CampaignOptionListService,
  CampaignTabsService,
  CampaignService
} from '../../services';

import { updatePresetOptionSearch, newUpdateCampaignPresetOption, loadCampaign, clearCampaignSelected } from 'app/campaign/features/campaign.actions';
import { selectCampaignSelected } from 'app/campaign/features/campaign.selectors';
import { AddSponsorGroup, getSponsorGroupList } from 'app/sponsor-group/features/sponsor-group/sponsor-group.actions';
import { selectSponsorGroup } from 'app/sponsor-group/features/sponsor-group/sponsor-group.selectors';

import { PeerToPeerPresetOptionSchema, PeerToPeerSchema } from 'app/campaign/structure/peer-to-peer';

import {
  PEER_TO_PEER_ACCORDION_SETTINGS_PRODVIDER,
  PEER_TO_PEER_ACCORDION_SETTINGS_TOKEN,
  PEER_TO_PEER_SETTINGS_PROVIDER,
  PEER_TO_PEER_SETTINGS_TOKEN,
  CAMPAIGN_TOKEN,
  OPTION_LIST_TOKEN
} from 'app/campaign/tokens';
import {
  SPONSOR_GROUP_LIST_TOKEN,
  SPONSOR_GROUP_TOKEN
} from 'app/sponsor-group/tokens';

import {
  campaignProvider,
  optionListProvider
} from 'app/campaign/factories';
import {
  sponsorGroupListProvider,
  sponsorGroupProvider
} from 'app/sponsor-group/factories';
import { PresetOptionCollection } from 'app/campaign/models/preset-options-collection.model';

import { CampaignPeerToPeerFundraisingOptionComponent } from '../campaign-peer-to-peer-fundraising-option/campaign-peer-to-peer-fundraising-option.component';
import { CampaignSponsorComponent } from '../campaign-sponsor/campaign-sponsor.component';
import { SponsorGroupListEventHandlerService } from 'app/sponsor-group/services/sponsor-group-list-event-handler.service';
import { SponsorGroupEventHandlerService } from 'app/sponsor-group/services/sponsor-group-event-handler.service';
import { ImageService } from 'app/core/services/image.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';

@Component({
  selector: 'app-campaign-peer-to-peer-fundraising',
  templateUrl: './campaign-peer-to-peer-fundraising.component.html',
  styleUrls: ['./campaign-peer-to-peer-fundraising.component.scss'],
  providers: [
    PEER_TO_PEER_SETTINGS_PROVIDER,
    PEER_TO_PEER_ACCORDION_SETTINGS_PRODVIDER,
    campaignProvider,
    optionListProvider,
    sponsorGroupListProvider,
    sponsorGroupProvider
  ]
})
export class CampaignPeerToPeerFundraisingComponent implements OnInit, AfterViewInit, OnDestroy {
  destroyRef = inject(DestroyRef)
  @ViewChild('tabs')
  set tabs(tabs: MdbTabsComponent) {
    this.tabsService.tabs = tabs;
  };
  get tabs(): MdbTabsComponent {
    return this.tabsService.tabs;
  }

  @ViewChild(CampaignPeerToPeerFundraisingOptionComponent)
  public optionComponent: CampaignPeerToPeerFundraisingOptionComponent;

  @ViewChild(CampaignSponsorComponent)
  public sponsorComponent: CampaignSponsorComponent;

  @Input()
  public id: string = null;

  public sponsorGroupControl: UntypedFormControl = new UntypedFormControl(null, []);
  public sponsorGroupEmpty: boolean = true;

  public campaign$ = this.store.pipe(
    select(selectCampaignSelected)
  );

  public campaign: UntypedFormGroup = null;
  public campaignTypeData: UntypedFormGroup = null;
  public sponsors: UntypedFormArray = null;

  public sponsorsCollection = null;

  public selectedOption = null;
  public selectedOptionIndex = null;
  public selectedOptionIndexIsFirst = null;
  public selectedOptionIndexIsLast = null;

  public selectedSponsor = null;
  public selectedSponsorIndex = null;

  public scrollToIndex = 0;

  public step: number = 0;
  public mode: string = 'list';
  public sponsorMode: string = 'first-step';

  public search: UntypedFormControl = new UntypedFormControl('', []);
  public toggleSearch: boolean = false;

  public submitted: boolean = false;

  constructor(
    private router: Router,
    private store: Store,
    private fb: UntypedFormBuilder,
    private campaignService: CampaignService,
    private element: ElementRef,
    private cdr: ChangeDetectorRef,
    @Inject(PEER_TO_PEER_SETTINGS_TOKEN) public settings: any,
    @Inject(PEER_TO_PEER_ACCORDION_SETTINGS_TOKEN) public accordion: any,
    @Inject(CAMPAIGN_TOKEN) public campaignFactory: any,
    @Inject(OPTION_LIST_TOKEN) public optionListFactory: any,
    @Inject(SPONSOR_GROUP_LIST_TOKEN) public sponsorGroupListFactory: any,
    @Inject(SPONSOR_GROUP_TOKEN) public sponsorGroupFactory: any,
    public accordionService: AccordionService,
    public tabsService: CampaignTabsService,
    public campaignFormService: CampaignFormService,
    public campaignOptionListService: CampaignOptionListService,
    public sponsorGroupListService: SponsorGroupListService,
    public sponsorGroupListEventHandlerService: SponsorGroupListEventHandlerService,
    public sponsorGroupEventHandlerService: SponsorGroupEventHandlerService,
    public imageService: ImageService
  ) {
    this.campaign = this.fb.group({});
    this.campaignFormService.container = this.element;
    this.campaignFormService.form = this.campaign;
    this.campaignFormService.schema = PeerToPeerSchema;
    this.campaignFormService.generate();

    this.campaignTypeData = this.campaign.get('campaignTypeData') as UntypedFormGroup;
    this.sponsors = this.campaign.get('sponsors') as UntypedFormArray;

    this.sponsorsCollection = new PresetOptionCollection(this.sponsors.controls);
    this.sponsorsCollection.search = '';
    this.sponsorsCollection.applySearch();

    this.accordionService.map = accordion;
    this.tabsService.lastStep = 2;
  }

  ngOnInit(): void {
    if(this.id) {
      this.store.dispatch({
        type: loadCampaign.type,
        payload: { id: this.id }
      });
    }

    this.store.dispatch({
      type: getSponsorGroupList.type
    });

    this.search.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(payload => {
      this.store.dispatch({
        type: updatePresetOptionSearch.type,
        payload
      });
    });

    this.sponsorGroupControl.valueChanges.pipe(
      switchMap(id => {
        return this.store.select(selectSponsorGroup(id))
      }),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(({ id }) => {
      this.store.dispatch({
        type: AddSponsorGroup.type,
        payload: {
          campaign: { id: this.campaign.get('id').value },
          sponsorGroup: { id }
        }
      });

      this.sponsorMode = 'second-step';
      this.sponsorGroupControl.reset(null, { emitEvent: false });
    })

    this.sponsors.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.sponsorGroupEmpty = _.isEmpty(this.sponsors.controls);
    })

    this.sponsorGroupEventHandlerService.onChangeState.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.cdr.markForCheck();
    });

    this.campaign.get('streetAddressRequired').valueChanges.pipe(
      filter(value => !value),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.campaignTypeData.get('streetAddressRequired').setValue(false);
    });

    this.campaign.get('phoneNumRequired').valueChanges.pipe(
      filter(value => !value),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.campaignTypeData.get('phoneNumRequired').setValue(false);
    });

    this.campaign.get('additionalInfoRequired').valueChanges.pipe(
      filter(value => !value),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.campaignTypeData.get('additionalInfoRequired').setValue(false);
    });

    this.campaign.get('additionalInfoSelectRequired').valueChanges.pipe(
      filter(value => !value),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.campaignTypeData.get('additionalInfoSelectRequired').setValue(false);
    });

    this.campaign.get('dedicationEnabled').valueChanges.pipe(
      filter(value => !value),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.campaignTypeData.get('dedicationEnabled').setValue(false);
    });
  }

  ngAfterViewInit(): void {
    this.campaign$.pipe(
      filter(campaign => !_.isNull(campaign)),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.sponsorGroupEmpty = _.isEmpty(this.sponsors.controls);
    });

    this.sponsorGroupListEventHandlerService.onSelectSponsorGroup.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((selected) => {
      const id = selected ? selected.id: null;
      this.sponsorMode = _.isNull(id) ? 'first-step': 'second-step';
    })

    this.campaignFormService.form.markAsPristine();
  }

  ngOnDestroy(): void {
    this.store.dispatch({
      type: updatePresetOptionSearch.type,
      payload: ''
    });

    this.store.dispatch({
      type: clearCampaignSelected.type
    });

    this.reset();
  }

  reset(): void {
    this.accordionService.reset();
    this.tabsService.reset();
    this.campaignFormService.reset();
    this.campaignOptionListService.reset();
    this.sponsorGroupListService.reset();

    this.campaignFactory.destroy();
    this.optionListFactory.destroy();
    this.sponsorGroupListFactory.destroy();
  }

  onCancel() {
    if(this.campaignFormService.form.pristine) {
      return this.router.navigateByUrl('campaign/list');
    }

    const action = DialogActions.openDialog({
      payload: {
        name: "confirmComponent",
        options: {
          size: 'small',
          modalClass:'modal--paybee modal-sm',
          containerClass:'mdb-modal-backdrop-paybee'
        },
        initialState: {
          modalTitle: "Unsaved Campaign Settings",
          text: `Do you want to save?`,
          buttonCancel: "No",
          buttonConfirm: "Yes",
          callback: (result) => {
            if(result == false) {
              return this.router.navigateByUrl('campaign/list');
            }
            const saved = this.onSave({redirect: false, checkCustom: false});
            if(saved) {
              return this.router.navigateByUrl('campaign/list');
            }
          }
        }
      }
    });
    this.store.dispatch(action);
  }

  onEditOption(event) {
    const list = this.campaignOptionListService.activeList;
    const currentIndex = list.findIndex(item => item.data.id === event.option.id);
    const { data: option } = list[currentIndex];

    const form = new UntypedFormGroup({});
    this.campaignService.generateForm(form, PeerToPeerPresetOptionSchema);
    this.campaignService.initializeForm(form, option, PeerToPeerPresetOptionSchema);

    this.selectedOption = form;
    this.selectedOptionIndex = currentIndex;
    this.selectedOptionIndexIsFirst = this.selectedOptionIndex === 0 ? true: false;
    this.selectedOptionIndexIsLast = this.selectedOptionIndex === list.length -1 ? true: false;
    this.changeMode('option-form');
  }

  goToPrevOption() {
    if(this.selectedOptionIndexIsFirst) return;
    if(this.selectedOption.valid) {
      const optionValue: any = this.campaignService.generateRequestObject(this.selectedOption, PeerToPeerPresetOptionSchema);
      this.store.dispatch({
        type: newUpdateCampaignPresetOption.type,
        payload: {
          campaign: this.campaign.value,
          option: optionValue
        }
      });

      const list = this.campaignOptionListService.activeList;
      const currentIndex = list.findIndex(item => item.data.id === optionValue.id);
      const { data: option } = list[currentIndex - 1];

      const form = new UntypedFormGroup({});
      this.campaignService.generateForm(form, PeerToPeerPresetOptionSchema);
      this.campaignService.initializeForm(form, option, PeerToPeerPresetOptionSchema);

      this.selectedOption = form;
      this.selectedOptionIndex = currentIndex - 1;
      this.selectedOptionIndexIsFirst = this.selectedOptionIndex === 0 ? true: false;
      this.selectedOptionIndexIsLast = this.selectedOptionIndex === list.length -1 ? true: false;
    }
    if(this.selectedOption.invalid) {
      this.campaignFormService.isNotValid();
      this.selectedOption.markAllAsTouched();
    }
  }

  goToNextOption() {
    if(this.selectedOptionIndexIsLast) return;
    if(this.selectedOption.valid) {
      const optionValue: any = this.campaignService.generateRequestObject(this.selectedOption, PeerToPeerPresetOptionSchema);
      this.store.dispatch({
        type: newUpdateCampaignPresetOption.type,
        payload: {
          campaign: this.campaign.value,
          option: optionValue
        }
      });

      const list = this.campaignOptionListService.activeList;
      const currentIndex = list.findIndex(item => item.data.id === optionValue.id);
      const { data: option } = list[currentIndex + 1];

      const form = new UntypedFormGroup({});
      this.campaignService.generateForm(form, PeerToPeerPresetOptionSchema);
      this.campaignService.initializeForm(form, option, PeerToPeerPresetOptionSchema);

      this.selectedOption = form;
      this.selectedOptionIndex = currentIndex + 1;
      this.selectedOptionIndexIsFirst = this.selectedOptionIndex === 0 ? true: false;
      this.selectedOptionIndexIsLast = this.selectedOptionIndex === list.length -1 ? true: false;
    }
    if(this.selectedOption.invalid) {
      this.campaignFormService.isNotValid();
      this.selectedOption.markAllAsTouched();
    }
  }

  changeMode(mode) {
    this.mode = mode;
  }

  onChangeCampaignOption(result) {
    this.mode = 'list';
    this.scrollToIndex = this.selectedOptionIndex;
    this.selectedOption = null;
    this.selectedOptionIndex = null;

    if(result) {
      this.campaignFormService.save({redirect: false, checkCustom: false});
    }
  }

  onChangeCampaignSponsor(event) {
    this.mode = 'list';
    this.scrollToIndex = this.selectedSponsorIndex;
    this.selectedSponsor = null;
    this.selectedSponsorIndex = null;
  }

  onSave(options = {redirect: true, checkCustom: true}) {
    return this.campaignFormService.save(options);
  }

  editSponsor(event) {
    this.mode = 'sponsor-form'
    this.selectedSponsor = event.sponsor;
    this.selectedSponsorIndex = event.index;
  }

  resetSearch() {
    this.search.setValue('');
  }
}
